// api/wechat.js
import axios from '@/interfaces'

// 业务线编码，作为需区分业务线的接口路径前缀（assist-助理）
const BIZ_LINE = import.meta.env.VITE_BIZ_LINE || 'assist'

/**
 * 生成微信授权URL
 */
export const generateAuthUrl = (redirectUri, scope) => {
  return axios.get('/wx/auth/url', {
    params: { redirectUri, scope }
  }).then(res => {
    return res.data
  })
}

/**
 * 使用code登录
 */
export const wxLogin = (code) => {
  return axios.get(`/${BIZ_LINE}/wx/auth/login`, {
    params: { code }
  }).then(res => res.data)
}

/**
 * 校验文本是否符合规则
 */
export const checkText = (data) => {
  return axios.post('/wx/v1/check/text', data).then(res => res.data)
}
